'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setActiveLocaleActionFinished = exports.setActiveLocaleAction = undefined;
exports.showUserMessage = showUserMessage;
exports.toggleTroubleshootMode = toggleTroubleshootMode;
exports.setActiveLocale = setActiveLocale;

var _UserMessage = require('MeetingsLib/models/UserMessage');

var _UserMessage2 = _interopRequireDefault(_UserMessage);

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _fluxActions = require('flux-actions');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function showUserMessage(_ref) {
  var type = _ref.type,
      content = _ref.content;

  return {
    type: _ActionTypes2.default.SHOW_USER_MESSAGE,
    userMessage: (0, _UserMessage2.default)({ type: type, content: content })
  };
}

function toggleTroubleshootMode(active) {
  return {
    type: _ActionTypes2.default.TOGGLE_TROUBLESHOOT_MODE,
    active: active
  };
}

var setActiveLocaleAction = exports.setActiveLocaleAction = (0, _fluxActions.createAction)(_ActionTypes2.default.SET_ACTIVE_LOCALE);

var setActiveLocaleActionFinished = exports.setActiveLocaleActionFinished = (0, _fluxActions.createAction)(_ActionTypes2.default.SET_ACTIVE_LOCALE_FINISHED, function (payload) {
  return payload;
});

function setActiveLocale(locale) {
  return function (dispatch) {
    dispatch(setActiveLocaleAction());
    return _I18n2.default.changeLocale(locale).then(function () {
      dispatch(setActiveLocaleActionFinished(locale));
    });
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/actions/UIActions.js
// module id = 125
// module chunks = 0